// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/deals-feature/deals-feature.component.scss
// module id = 255
// module chunks = 0